import type { EdmDateTimeOffset, EdmGuid, TokenType } from "../../odata-types.ts";
import type { ComparisonExpression } from "../ComparisonExpression.ts";
import type { FunctionExpression } from "../FunctionExpression.ts";
import type { GroupExpression } from "../GroupExpression.ts";
import type { InExpression } from "../InExpression.ts";
import type { LambdaExpression } from "../LambdaExpression.ts";
import type { LiteralExpression } from "../LiteralExpression.ts";
import type { LogicalExpression } from "../LogicalExpression.ts";
import type { NotExpression } from "../NotExpression.ts";
import type { PropertyExpression } from "../PropertyExpression.ts";

export type ComparisonValue =
    | { type: "literal"; value: string | number | boolean | null | EdmGuid | EdmDateTimeOffset }
    | { type: "now" }
    | { type: "relativeDate"; operator: typeof TokenType.SUB | typeof TokenType.ADD; duration: string };

export type FilterExpression =
    | ComparisonExpression
    | FunctionExpression
    | GroupExpression
    | InExpression
    | LambdaExpression
    | LogicalExpression
    | NotExpression
    | PropertyExpression
    | LiteralExpression;

export interface PropertyInfo {
    propertyName: string;
    collection?: string;
}

export function parsePath(pathOrString: string[] | string): string[] {
    return typeof pathOrString === "string" ? pathOrString.split("/").filter(s => s.length > 0) : pathOrString;
}

export function pathToPropertyInfo(path: string[]): PropertyInfo {
    if (path.length === 1) {
        return { propertyName: path[0] };
    }

    return {
        propertyName: path[path.length - 1],
        collection: path[0]
    };
}

export function joinPath(path: string[]): string {
    return path.join("/");
}
